/**
 * FileName : user.ts
 * ProjectName : admin
 * Author : terrorblade
 * Created Date: 2021-08-17 15:27:05
 * Description :
 * -----
 * Last Modified:
 * Modified By :
 * -----
 * Copyright (c) 2021 Magina Corporation. All rights reserved.
 */
import {ReturnUser} from 'src/api/user/type';
export const initState = {
    ip: '',
    sysType: '100068',
    subName: '',
    systemType: '2', // 1:PVMS;2:MDR;3:PVMS+MDR
    moneyUnit: '',
    webSocketInfo: '',
    operatorType: '',
    sysUser: {
        operatorName: '',
        operatorId: '',
        operatorGuid: '',
        nodeNo: [],
        groupList: '',
        subSys: '',
        username: '',
        phone: '',
        email: '',
    },
    sysRole: {
        groupGuid: '',
        groupName: '',
    },
    menuList: [],
    roleObj: {},
};

export type ACTION = {
  type: string;
  value: ReturnUser;
}

export const setUsername = 'SET_USERNAME'; // 消息列表的展示与隐藏

export const CLEAR_LOGIN = 'CLEAR_LOGIN';

/**
 * 设置用户账户
 * @param {initState} state state
 * @param {ACTION} action action
 * @returns {state} state
 */
export const userInfo = (state: ReturnUser = initState, action: ACTION) => {
    switch (action.type) {
        case setUsername:
            return state = action.value;
        case CLEAR_LOGIN:
            return state = initState;
        default:
            return state;
    }
};
